const formatToTailwind = (color: string) => `[${color}]`;

// eslint-disable-next-line import/prefer-default-export
export { formatToTailwind };
